import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";

export interface AcceptanceCriterion {
  id: string;
  description: string;
  check: string;
}

export interface DraftedSpec {
  title: string;
  description: string;
  suggestedBudgetUsdc: number;
  inputData: Record<string, unknown>;
  acceptanceCriteria: AcceptanceCriterion[];
}

export interface DraftSpecInput {
  rawText: string;
  templateId?: string;
}

// POST /intake/draft — turn a plain-English request into a bounded,
// machine-checkable job spec. Stateless; does not create a job.
export const useDraftSpec = () => {
  return useMutation<DraftedSpec, unknown, DraftSpecInput>({
    mutationFn: async (payload: DraftSpecInput) => {
      const { data } = await api.post("/intake/draft", payload);
      return data.data ?? data;
    },
  });
};
